import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=709fbb33&scoped=true&lang=pug&"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js&"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=709fbb33&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fbb33",
  null
  
)

export default component.exports